"use client";
import { useEffect, useRef, useState } from "react";
import { HoverButton } from "./hoverButton";
import { MdKeyboardArrowUp } from "react-icons/md";
import { cn } from "@/lib/utils/utils";

export default function ScrollUp({
  className,
  distance = 400,
  delay = 300,
}: {
  className?: string;
  distance?: number;
  delay?: number;
}) {
  const lastExecuted = useRef<number>(Date.now());
  const [show, setShow] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    const handleScroll = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (Date.now() - lastExecuted.current < delay) return;
        lastExecuted.current = Date.now();
        if (window.scrollY > distance) {
          setShow(true);
        } else {
          setShow(false);
        }
      }, delay);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timer);
    };
  }, [delay, distance]);

  return (
    <HoverButton
      variant="default"
      coverClassName="cover right-0 left-0 w-full"
      className={cn(
        "fixed bottom-5 right-5 rouned-full w-12 h-12 text-white hover:[&>div]:bg-secondary [&>div]:h-0 hover:[&>div]:h-12 transition-opacity duration-150 rounded-full overflow-hidden",
        show ? "opacity-100" : "opacity-0",
        className,
      )}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
    >
      <MdKeyboardArrowUp className="size-6" />
    </HoverButton>
  );
}
